import { Component, Input, OnInit } from '@angular/core';
import { downloadFile } from '../../../tools/reports-tools';
import { ReportsService } from '../../../services/reports.service';
import { ClientHomePage, ClientSetup, HomePageReportModel } from '../../../models/client';
import { ReportModel } from '../../../models/reports';
import { Select, Store } from '@ngxs/store';
import { ClientSelectionState } from '../../../state/ClientSelectionState/ClientSelection.state';
import { Observable, of } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators';
import { Navigate } from '@ngxs/router-plugin';
import { AclService } from '../../../services/acl.service';
import { ClientFeatureWhitelistService } from '../../../services/client-feature-whitelist.service';

@Component({
  selector: 'lib-quick-reports',
  templateUrl: './quick-reports.component.html',
  styleUrls: ['./quick-reports.component.scss'],
  standalone: false
})
export class QuickReportsComponent implements OnInit {
  @Input()
  report: HomePageReportModel;
  @Select(ClientSelectionState.clientCode)
  clientCode: Observable<string>;

  public canAccessGeneralLedger = false;
  private isCsr = false;

  constructor(
    private reportService: ReportsService,
    private store: Store,
    private aclService: AclService,
    private whitelistService: ClientFeatureWhitelistService
  ) {}

  ngOnInit(): void {
    this.aclService.CurrentUserHasMinimumRole('CSR1').subscribe(result => {
      this.isCsr = result;
      this.store.selectOnce(ClientSelectionState.clientSetup).subscribe(setup => {
        if (this.isCsr && setup.HasGeneralLedger) {
          this.canAccessGeneralLedger = true;
        }
        if (!this.isCsr && setup.HasGeneralLedger) {
          this.clientCode
            .pipe(
              mergeMap(code => {
                if (code != null) {
                  return this.whitelistService.checkWhitelistForFeature(code, 'generalLedger');
                }
                return of(false);
              })
            )
            .subscribe(result => {
              this.canAccessGeneralLedger = result;
            });
        }
      });
    });
  }
  downloadReport(reportModel: ReportModel) {
    this.clientCode
      .pipe(
        first(),
        mergeMap(clientCode => {
          return this.reportService.downloadRecurringReport(
            clientCode,
            [reportModel.Filename],
            reportModel.MimeType[0],
            this.report.PayDate,
            this.report.PayDate
          );
        })
      )
      .subscribe(x => {
        const header = x.headers.get('X-Download-Filename');
        const name: string = JSON.parse(header).name;
        downloadFile(x.body, name);
      });
  }

  glClicked() {
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
      this.store.dispatch(new Navigate([`/client/${code}/general-ledger`]));
    });
  }
}
